module.exports = __webpack_public_path__ + "img/Sound4.a51939fa.png";